import { Namespace, TFunction } from 'react-i18next';
import * as Yup from 'yup';

import { AddressValidationSchema } from '@pages/Warehouses/data/validation';

import { IFormValues } from './interfaces';

export const ValidationSchema = (t: TFunction<Namespace<'validation'>>): Yup.SchemaOf<IFormValues> =>
  Yup.object().shape({
    epd_enabled: Yup.boolean(),
    address: AddressValidationSchema(t).required(t('required')),
    name: Yup.string().trim().required(t('required')),
    customer_scope_id: Yup.number().required(t('required')),
  });
